import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PlateDisplay from "./PlateDisplay";
import { useNavigate } from "react-router-dom";

const PLATE_STYLES = [
  "malaysia-new",
  "malaysia-legacy",
  "malaysia-cursive",
  "malaysia-taxi",
  "malaysia-diplomat",
  "thai",
  "singapore",
];

const LogoPlate = () => {
  const [randomStyle, setRandomStyle] = useState(
    () => PLATE_STYLES[Math.floor(Math.random() * PLATE_STYLES.length)]
  );

  useEffect(() => {
    // Change style on each page load
    setRandomStyle(
      PLATE_STYLES[Math.floor(Math.random() * PLATE_STYLES.length)]
    );
  }, []);

  const handleClick = (e) => {
    // Prevent navigation if clicking the plate directly
    if (e.target.closest(".plate-display")) {
      // Get a new random style different from current
      let newStyle;
      do {
        newStyle =
          PLATE_STYLES[Math.floor(Math.random() * PLATE_STYLES.length)];
      } while (newStyle === randomStyle);
      setRandomStyle(newStyle);
    }
  };

  return (
    <Link to="/" className="group flex items-center" onClick={handleClick}>
      <div className="transform transition-transform duration-300 group-hover:scale-105">
        <PlateDisplay
          plate="G80 OR NOT"
          plateStyle={randomStyle}
          size="logo"
          className="hover:shadow-lg transition-shadow duration-300 plate-display cursor-pointer"
        />
      </div>
    </Link>
  );
};

export default LogoPlate;
